module.exports = __webpack_public_path__ + "assets/img/garage.26b4f856.svg";